import React, { useEffect, useMemo, useRef } from 'react';

import { isSameDay } from 'date-fns';
import { useAuth } from '~/hooks/auth';
import OpenCashModal, { OpenCashModalPropsRef } from './OpenCashModal';

export function CashButton(): JSX.Element {
  const { company } = useAuth();

  const ref = useRef<OpenCashModalPropsRef>(null);

  const cashIsOpen = useMemo(() => {
    if (company.uid && company.cashOpenedAt) {
      const cashOpenedAt = new Date(
        (company.cashOpenedAt as any).seconds * 1000,
      );

      return isSameDay(new Date(), cashOpenedAt);
    }

    return false;
  }, [company]);

  return (
    <>
      <li>
        <div
          role="button"
          className="nk-quick-nav-icon d-flex flex-column align-items-center"
          onClick={() => ref.current?.open()}
        >
          <em
            className={`icon ni ni-toggle-${
              cashIsOpen ? 'on text-success' : 'off'
            }`}
          />
          <span className="fs-10px" style={{ marginTop: -6 }}>
            {cashIsOpen ? 'Fechar Caixa' : 'Abrir Caixa'}
          </span>
        </div>
      </li>

      <OpenCashModal ref={ref} isOpen={cashIsOpen} />
    </>
  );
}
